import { render, staticRenderFns } from "./ycd-channel-index.vue?vue&type=template&id=f953a90c&scoped=true&"
import script from "./ycd-channel-index.vue?vue&type=script&lang=ts&"
export * from "./ycd-channel-index.vue?vue&type=script&lang=ts&"
import style0 from "./ycd-channel-index.vue?vue&type=style&index=0&id=f953a90c&lang=less&scoped=true&"
import style1 from "./ycd-channel-index.vue?vue&type=style&index=1&id=f953a90c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f953a90c",
  null
  
)

export default component.exports